import * as React from "react";

import { formatCurrency } from "app/utils/filters";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

import EditWallet from "app/components/AppComponents/SnapScan/Wallet/Wallet.UpdateWallet";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Wallet Name",
    render: row => {
      return (
        <BackOfficeLink backofficeUrl={`/snapscan/wallets/${row.name}/users`}>
          {row.name}
        </BackOfficeLink>
      );
    }
  },
  {
    name: "Voucher Name",
    render: row => {
      return (
        <BackOfficeLink backofficeUrl={`/snapscan/vouchers/${row.name}/users`}>
          {row.name}
        </BackOfficeLink>
      );
    }
  },
  {
    name: "Edit",
    render: row => {
      return <EditWallet type={"edit"} name={row.name} />;
    }
  },
  {
    name: "Email",
    render: row => row.email
  },
  {
    name: "External Reference",
    render: row => {
      return (
        <BackOfficeLink
          backofficeUrl={`/snapscan/ops/users/${row.external_reference}/summary`}
        >
          {row.external_reference}
        </BackOfficeLink>
      );
    }
  },
  {
    name: "Balance",
    cellProps: { align: "right" },
    render: row => `R${formatCurrency(row.balance)}`
  }
];

export default columnConfigs;
